const getErrorMessage = (error: unknown): string => {
  if (typeof error === 'string') return error;

  if (
    error &&
    typeof error === 'object' &&
    'detail' in error &&
    typeof (error as { detail?: unknown }).detail === 'string'
  ) {
    return (error as { detail: string }).detail;
  }

  if (error instanceof Error && error.message) {
    return error.message;
  }

  return 'Failed to process payment';
};

export { getErrorMessage };
